import React, { useState } from "react";
import Footer from "../components/Footer";

const Error404 = ({ lang, translations }) => {
  const [hover, setHover] = useState(false);

  return (
    <div>
    <div className='background-image-error'> 
      <div className="flex-column title-top-padding2">
        <div className='flex h2-title-blue'>
          <h2>{translations[lang].errorsubtitle}</h2>
        </div>
        {/* <div>
          <Subtitle subtitle={translations[lang].errorsubtitle} />
        </div> */}
      
      
      <div className="flex">
        <a
          href={"/"}
          className="button1 no-link"
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <div className="flex">
          <img
            className="back-icon"
            src={hover ? '/img/back-blue.png' : '/img/back-white.png'}
            alt={translations[lang].backicon}
            style={{
              cursor: 'pointer',
              transition: '0.3s ease-in-out',
            }}
          />

            <p>&nbsp;&nbsp;&nbsp;</p>
            <p className="text-no-margin">{translations[lang].errorback}</p>
          </div>
        </a>
      </div>
      </div>
      
    </div>
    <Footer lang={lang} translations={translations}/>
    </div>
  );
};

export default Error404;
